// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your Firebase config (use the one you got)
const firebaseConfig = {
  apiKey: "AIzaSyDMCZmA2VhXetrjIoEqSGZ8uFjb-7dQGHI",
  authDomain: "placify-institute.firebaseapp.com",
  projectId: "placify-institute",
  storageBucket: "placify-institute.firebasestorage.app",
  messagingSenderId: "794814022422",
  appId: "1:794814022422:web:716522821c629a6cf58637",
  measurementId: "G-3Y44PGM839"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
